import React, { useState, useEffect } from 'react';
import apiService from '../Common/Configurations/APIService';
import config from '../Common/Configurations/APIConfig';
import './TemplateWizard.css';
import masterDestinationsList from '../Data/DestinationPlaces.json'; 

const STEPS =["Branding", "Destinations", "Header", "Hero Banner", "About Us", "Contact Info", "SEO Settings", "Footer"];

const TemplateSetupWizard = ({ show, onClose, templateId, user, onSave }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [loading, setLoading] = useState(false); 
  const[destinationSearch, setDestinationSearch] = useState("");
  const [logoFile,setLogoFile] = useState(null)

  const [formData, setFormData] = useState({
    branding: {
      logoUrl: user?.companyLogo || user?.brandName || "",
      companyName: user?.companyname || "My Travel Agency",
      brandName: user?.brandName || "My Travel Agency",
      email: user?.companyEmail || "contact@agency.com",
      phones: [user?.companyPhone || ""],
      whatsapp: [user?.companyWhatsappnumber || ""], 
      socials: { facebook: "", instagram: "", x: "", linkedin: "", youtube: "" }
    },
    destinations: [], 
    header: [],
    slides:[],
    aboutData: {
      title: "Defining the Future of Travel",
      description: "Welcome to our agency. We specialize in creating unique experiences that last a lifetime.",
      image: "https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg"
    },
    contactData: {
      title: "Get In Touch",
      description: "Plan your next dream vacation with our experts.",
      officeHours: "Mon-Sat: 9 AM - 6 PM",
      mapIframeUrl: ""
    },
     seoData: {
      metaTitle: "",
      metaDescription: "",
      metaKeywords: ""
    },
    footer: { aboutText: "Discover the world with us.", copyright: "© 2026 All Rights Reserved." }
  });

  useEffect(() => {
    if (show && templateId) {
      const fetchDefaults = async () => {
        setLoading(true); 
        try {
          const data = await apiService.getById(config.GETTEMPLATEPREVIEWDATA, templateId);
          
          // 1. FLATTEN MASTER JSON WITH UNIQUE IDs
          const flatMasterList =[];
          masterDestinationsList.forEach(country => {
              flatMasterList.push({
                  id: country.destinationId, // <-- Added unique ID
                  name: country.destination,
                  type: 'Country',
                  image: country.imageSrc || `https://via.placeholder.com/400x300?text=${encodeURIComponent(country.destination)}`,
                  checked: false 
              });
              
              if (country.places && country.places.length > 0) {
                  country.places.forEach(place => {
                      flatMasterList.push({
                          id: place.placeId, // <-- Added unique ID
                          name: place.placeName,
                          type: 'City',
                          parentCountry: country.destination,
                          image: place.placeSrc || `https://via.placeholder.com/400x300?text=${encodeURIComponent(place.placeName)}`,
                          checked: false 
                      });
                  });
              }
          });

          const hdrs = data.defaultHeaderJson ? JSON.parse(data.defaultHeaderJson) :[];
          const hero = data.defaultHeroJson ? JSON.parse(data.defaultHeroJson) : { slides:[] };
          const abt = data.defaultAboutJson ? JSON.parse(data.defaultAboutJson) : formData.aboutData;
          const cnt = data.defaultContactJson ? JSON.parse(data.defaultContactJson) : formData.contactData;
          const seo = data.defaultSeoJson ? JSON.parse(data.defaultSeoJson) : formData.seoData;
          const ftr = data.defaultFooterJson ? JSON.parse(data.defaultFooterJson) : formData.footer;

          setFormData(prev => ({
            ...prev,
            destinations: flatMasterList, 
            header: hdrs,
            slides: hero.slides.map(s => ({ ...s, subtitles: s.subtitle ? [s.subtitle] : [""] })),
            aboutData: abt, 
            contactData: cnt, 
            footer: ftr
          }));
        } catch (error) {
          console.error("Failed to load template defaults", error);
        } finally {
          setLoading(false); 
        }
      };
      fetchDefaults();
      setCurrentStep(0);
      setDestinationSearch(""); 
    }
  }, [show, templateId]);

  if (!show) return null;
const handleLogoUpload = (e) => {
  const file = e.target.files[0]

  if(file){
     setLogoFile(file)

     const url = URL.createObjectURL(file)

     setFormData(prev => ({
        ...prev,
        branding:{
          ...prev.branding,
          logoUrl:url
        }
     }))
  }
}
  // --- HANDLERS: BRANDING ---
  const handleBrandingChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, branding: { ...prev.branding, [name]: value } }));
  };

  const handlePhoneChange = (index, value) => {
    const newPhones = [...formData.branding.phones];
    newPhones[index] = value;
    setFormData(prev => ({ ...prev, branding: { ...prev.branding, phones: newPhones } }));
  };

  const addPhone = () => {
    setFormData(prev => ({ ...prev, branding: { ...prev.branding, phones: [...prev.branding.phones, ""] } }));
  };

  const removePhone = (indexToRemove) => {
    setFormData(prev => ({
      ...prev,
      branding: {
        ...prev.branding,
        phones: prev.branding.phones.filter((_, index) => index !== indexToRemove)
      }
    }));
  };

  const handleSocialChange = (network, value) => {
    setFormData(prev => ({ ...prev, branding: { ...prev.branding, socials: { ...prev.branding.socials, [network]: value } } }));
  };

  

  // --- HANDLERS: DESTINATIONS ---
   const handleDestinationToggle = (index) => {
    const newDests = [...formData.destinations];
    newDests[index].checked = !newDests[index].checked;
    setFormData(prev => ({ ...prev, destinations: newDests }));
  };

  // --- HANDLERS: HEADER & HERO & FOOTER ---
  const handleHeaderChange = (index, value) => {
    const newHeader =[...formData.header];
    newHeader[index].label = value;
    setFormData(prev => ({ ...prev, header: newHeader }));
  };

  const handleSlideTitleChange = (sIdx, value) => {
    const newSlides = [...formData.slides];
    newSlides[sIdx].title = value;
    setFormData(prev => ({ ...prev, slides: newSlides }));
  };

  const handleSubtitleChange = (sIdx, subIdx, value) => {
    const newSlides = [...formData.slides];
    newSlides[sIdx].subtitles[subIdx] = value;
    setFormData(prev => ({ ...prev, slides: newSlides }));
  };

  const addSubtitle = (sIdx) => {
    const newSlides = [...formData.slides];
    newSlides[sIdx].subtitles.push("");
    setFormData(prev => ({ ...prev, slides: newSlides }));
  };

  const addNewSlide = () => {
    setFormData(prev => ({
        ...prev, 
        slides:[...prev.slides, { image: "https://via.placeholder.com/800x400", title: "New Slide", subtitles: [""] }]
    }));
  };

  const removeSlide = (sIdx) => {
    const newSlides = formData.slides.filter((_, index) => index !== sIdx);
    setFormData(prev => ({ ...prev, slides: newSlides }));
  };

  const handleSlideImageUpload = (sIdx, e) => {
    const file = e.target.files[0];
    if (file) {
      const url = URL.createObjectURL(file);
      const newSlides = [...formData.slides];
      newSlides[sIdx].image = url;
      setFormData(prev => ({ ...prev, slides: newSlides }));
    }
  };

  // --- SAVE FORMATTING ---
  //  const handleFinalSave = () => {
  //   const finalData = {
  //       CustomBrandingJson: JSON.stringify(formData.branding),
  //       DestinationsJson: JSON.stringify({ 
  //           destinations: formData.destinations.filter(d => d.checked).map(d => ({
  //               id: d.id, // <-- Save the ID too, just to be safe
  //               name: d.name,
  //               image: d.image 
  //           })) 
  //       }),
  //       HeaderJson: JSON.stringify(formData.header),
  //       HeroJson: JSON.stringify({ 
  //           slides: formData.slides.map(s => ({
  //               image: s.image, title: s.title, subtitle: s.subtitles.join(" | ") 
  //           }))
  //       }),
  //       AboutUsJson: JSON.stringify(formData.aboutData),
  //       ContactUsJson: JSON.stringify(formData.contactData),
  //        SeoJson: JSON.stringify(formData.seoData), 
  //       FooterJson: JSON.stringify(formData.footer),
  //        if(logoFile){
  //    form.append("LogoFile", logoFile)
  // }
  //   };
  //   onSave(finalData);
  // };

  const handleFinalSave = () => {

  const form = new FormData()

  form.append("CompanyId", user.cid)
  form.append("TemplateId", templateId)

  form.append("CustomBrandingJson", JSON.stringify(formData.branding))
  form.append("DestinationsJson", JSON.stringify({
     destinations: formData.destinations.filter(d => d.checked)
  }))

  form.append("HeaderJson", JSON.stringify(formData.header))

  form.append("HeroJson", JSON.stringify({
     slides: formData.slides.map(s => ({
       image: s.image,
       title: s.title,
       subtitle: s.subtitles.join(" | ")
     }))
  }))

  form.append("AboutUsJson", JSON.stringify(formData.aboutData))
  form.append("ContactUsJson", JSON.stringify(formData.contactData))
  form.append("SeoJson", JSON.stringify(formData.seoData))
  form.append("FooterJson", JSON.stringify(formData.footer))

  if (logoFile) {
     form.append("LogoFile", logoFile)
  }

  // ⭐ send data to TemplateGallery
  onSave(form)
}
  // --- UI RENDER LOGIC ---
  const renderStepContent = () => {
    switch (currentStep) {
      case 0: // Branding
        return (
          <div className="row g-4">
             <h4 className="mb-2 text-primary">Setup your Brand Identity</h4>
             <div className="col-12">
               <label className="form-label fw-bold">Company Logo</label>
               <div className="logo-preview-container">
                 <img src={formData.branding.logoUrl} alt="Logo" className="logo-preview" style={{maxHeight:'80px', objectFit:'contain'}} />
                 <div className="mt-2">
                   <input type="file" className="form-control form-control-sm" accept="image/*" onChange={handleLogoUpload} />
                   <small className="text-muted">Upload a transparent PNG for best results.</small>
                 </div>
               </div>
             </div>
             <div className="col-md-6">
               <label className="form-label fw-bold">Company Name</label>
               <input type="text" className="form-control" name="companyName" value={formData.branding.companyName} onChange={handleBrandingChange} />
             </div>
              <div className="col-md-6">
               <label className="form-label fw-bold">Brand Name</label>
               <input type="text" className="form-control" name="brandName" value={formData.branding.brandName} onChange={handleBrandingChange} />
             </div>
             <div className="col-md-6">
               <label className="form-label fw-bold">Email Address</label>
               <input type="email" className="form-control" name="email" value={formData.branding.email} onChange={handleBrandingChange} />
             </div>
             <div className="col-md-6">
               <label className="form-label fw-bold">WhatsApp Number</label>
               <input type="text" className="form-control" name="whatsapp" placeholder="+91 0000000000" value={formData.branding.whatsapp} onChange={handleBrandingChange} />
             </div>
             <div className="col-md-12 mt-4">
               <label className="form-label fw-bold">Phone Numbers</label>
               {formData.branding.phones.map((phone, index) => (
                 <div className="d-flex mb-2 gap-2" key={index}>
                   <input type="text" className="form-control" placeholder={`Phone ${index + 1}`} value={phone} onChange={(e) => handlePhoneChange(index, e.target.value)} />
                   {index > 0 && <button type="button" className="btn btn-outline-danger" onClick={() => removePhone(index)} title="Remove Phone">✖</button>}
                   {index === formData.branding.phones.length - 1 && <button type="button" className="btn btn-outline-primary" onClick={addPhone} title="Add Phone">➕</button>}
                 </div>
               ))}
             </div>
             <div className="col-12 mt-4">
               <label className="form-label fw-bold">Social Media Links</label>
               <div className="row g-3">
                 {Object.keys(formData.branding.socials).map((network) => (
                   <div className="col-md-6" key={network}>
                     <div className="input-group">
                       <span className="input-group-text bg-light fw-bold" style={{width: '100px', textTransform:'capitalize'}}>{network}</span>
                       <input type="text" className="form-control" placeholder={`${network} URL`} value={formData.branding.socials[network]} onChange={(e) => handleSocialChange(network, e.target.value)} />
                     </div>
                   </div>
                 ))}
               </div>
             </div>
          </div>
        );

     case 1: // Destinations
        const checkedDests = formData.destinations.filter(d => d.checked);
        
        const searchResults = formData.destinations.filter(d => {
            if (d.checked) return false; 
            if (destinationSearch === "") return false; 
            return d.name.toLowerCase().includes(destinationSearch.toLowerCase());
        }).slice(0, 20);

        return (
          <div className="d-flex flex-column h-100">
            <h4 className="mb-1 text-primary">Manage Featured Destinations</h4>
            <p className="text-muted small">Select the countries or cities you want to feature on your homepage.</p>

            {/* ACTIVE DESTINATIONS CHIPS */}
            <div className="mb-4">
               <h6 className="text-success mb-2">Selected Destinations ({checkedDests.length})</h6>
               <div className="d-flex flex-wrap gap-2" style={{ maxHeight: '150px', overflowY: 'auto' }}>
                  {checkedDests.map((dest) => {
                     // 👇 FIX: Search by UNIQUE ID instead of name
                     const realIndex = formData.destinations.findIndex(d => d.id === dest.id);
                     return (
                        <div key={dest.id} className="badge bg-primary d-flex align-items-center p-2" style={{fontSize: '0.9rem', cursor: 'pointer'}} onClick={() => handleDestinationToggle(realIndex)}>
                           {/* Add the parent country so you know WHICH Hyderabad it is! */}
                           {dest.name} {dest.type === 'City' ? `(${dest.parentCountry})` : ''} 
                           <span className="ms-2 text-white" style={{fontSize: '1.2rem', lineHeight: '1'}}>&times;</span>
                        </div>
                     );
                  })}
                  {checkedDests.length === 0 && <span className="text-muted small">No destinations selected. Start searching below!</span>}
               </div>
            </div>

            {/* SEARCH BAR */}
            <div className="mb-3">
                <input 
                    type="text" 
                    className="form-control form-control-lg border-primary shadow-none" 
                    placeholder="🔍 Search for a Country or City..." 
                    value={destinationSearch}
                    onChange={(e) => setDestinationSearch(e.target.value)}
                />
            </div>

            {/* SEARCH RESULTS LIST (TEXT ONLY) */}
            <div className="list-group flex-grow-1" style={{ maxHeight: '300px', overflowY: 'auto' }}>
              {destinationSearch === "" ? (
                  <div className="text-center text-muted mt-4">
                      <p>Type a destination name above to search from your master list.</p>
                  </div>
              ) : searchResults.length > 0 ? (
                  searchResults.map((dest) => {
                     // 👇 FIX: Search by UNIQUE ID instead of name
                     const realIndex = formData.destinations.findIndex(d => d.id === dest.id);
                     return (
                        <button 
                            key={dest.id} 
                            type="button" 
                            className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                            onClick={() => {
                                handleDestinationToggle(realIndex);
                                setDestinationSearch(""); 
                            }}
                        >
                            <div>
                                <span className="fw-bold">{dest.name}</span>
                                {dest.type === 'City' && <small className="text-muted ms-2">({dest.parentCountry})</small>}
                            </div>
                            <span className="badge bg-secondary rounded-pill">{dest.type}</span>
                        </button>
                     );
                  })
              ) : (
                  <div className="text-center text-muted mt-4">
                      <p>No destinations found matching "{destinationSearch}".</p>
                  </div>
              )}
            </div>
          </div>
        );

      case 2: // Header
         return (
            <div>
              <h4 className="mb-3 text-primary">Customize Navigation Menu</h4>
              <div className="row g-3">
                {formData.header.map((item, index) => (
                  <div className="col-md-6" key={index}>
                    <label className="form-label fw-bold">Menu Label {index + 1} (Path: {item.path})</label>
                    <input type="text" className="form-control" value={item.label} onChange={(e) => handleHeaderChange(index, e.target.value)} />
                  </div>
                ))}
              </div>
            </div>
          );

      case 3: // Hero Slides
         return (
            <div>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="text-primary mb-0">Hero Banner Images & Text</h4>
                <button className="btn btn-sm btn-success fw-bold" onClick={addNewSlide}>+ Add New Slide</button>
              </div>
  
              {formData.slides.map((slide, sIdx) => (
                <div key={sIdx} className="card mb-4 shadow-sm position-relative">
                  <div className="card-body">
                    <button 
                      className="btn btn-sm btn-danger position-absolute" 
                      style={{top: '10px', right: '10px'}} 
                      onClick={() => removeSlide(sIdx)}
                      title="Delete this slide"
                    >✖</button>
  
                    <h5 className="mb-3">Slide {sIdx + 1}</h5>
                    <div className="row g-3">
                      <div className="col-md-4 text-center">
                        <img src={slide.image} alt={`Slide ${sIdx+1}`} className="img-fluid rounded mb-2" style={{height: '150px', objectFit:'cover', width:'100%'}} />
                        <input type="file" className="form-control form-control-sm" accept="image/*" onChange={(e) => handleSlideImageUpload(sIdx, e)} />
                      </div>
                      <div className="col-md-8">
                        <label className="form-label fw-bold">Main Title</label>
                        <input type="text" className="form-control mb-3" value={slide.title} onChange={(e) => handleSlideTitleChange(sIdx, e.target.value)} />
                        
                        <label className="form-label fw-bold">Subtitles</label>
                        {slide.subtitles.map((sub, subIdx) => (
                          <div className="d-flex mb-2 gap-2" key={subIdx}>
                            <input type="text" className="form-control" placeholder={`Subtitle ${subIdx + 1}`} value={sub} onChange={(e) => handleSubtitleChange(sIdx, subIdx, e.target.value)} />
                            {subIdx === slide.subtitles.length - 1 && (
                              <button type="button" className="btn btn-outline-primary" onClick={() => addSubtitle(sIdx)} title="Add another subtitle line">+</button>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          );

       case 4: // About Us Step
        return (
          <div>
            <h4 className="mb-3 text-primary">Customize "About Us" Section</h4>
            <p className="text-muted mb-4">Introduce your travel agency to your customers.</p>
            
            <div className="mb-3">
              <label className="form-label fw-bold">Section Title</label>
              <input type="text" className="form-control" value={formData.aboutData.title} 
                onChange={(e) => setFormData({...formData, aboutData: {...formData.aboutData, title: e.target.value}})} 
              />
            </div>
            
            <div className="mb-3">
              <label className="form-label fw-bold">Description</label>
              <textarea className="form-control" rows="5" value={formData.aboutData.description}
                onChange={(e) => setFormData({...formData, aboutData: {...formData.aboutData, description: e.target.value}})}
              ></textarea>
            </div>
            
            <div className="mb-3">
              <label className="form-label fw-bold">Side Image URL</label>
              <input type="text" className="form-control" value={formData.aboutData.image} 
                onChange={(e) => setFormData({...formData, aboutData: {...formData.aboutData, image: e.target.value}})} 
              />
              {formData.aboutData.image && (
                <img src={formData.aboutData.image} alt="About Us" className="mt-2 rounded shadow-sm" style={{height: '100px', objectFit:'cover'}} />
              )}
            </div>
          </div>
        );

      case 5: // Contact Info Step
        return (
          <div>
            <h4 className="mb-3 text-primary">Customize "Contact Us" Section</h4>
            <p className="text-muted mb-4">Set up how customers can reach you from the Contact page.</p>

            <div className="mb-3">
              <label className="form-label fw-bold">Section Title</label>
              <input type="text" className="form-control" value={formData.contactData.title} 
                onChange={(e) => setFormData({...formData, contactData: {...formData.contactData, title: e.target.value}})} 
              />
            </div>
            
            <div className="mb-3">
              <label className="form-label fw-bold">Short Description</label>
              <input type="text" className="form-control" value={formData.contactData.description} 
                onChange={(e) => setFormData({...formData, contactData: {...formData.contactData, description: e.target.value}})} 
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold">Office Hours</label>
              <input type="text" className="form-control" placeholder="e.g., Mon-Sat: 9 AM - 6 PM" value={formData.contactData.officeHours} 
                onChange={(e) => setFormData({...formData, contactData: {...formData.contactData, officeHours: e.target.value}})} 
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold">Google Maps Embed URL (Optional)</label>
              <textarea className="form-control" rows="3" placeholder="<iframe src='https://www.google.com/maps/embed?...' ></iframe>" value={formData.contactData.mapIframeUrl} 
                onChange={(e) => setFormData({...formData, contactData: {...formData.contactData, mapIframeUrl: e.target.value}})} 
              ></textarea>
            </div>
          </div>
        );
        case 6: 
        return (
          <div>
            <h4 className="mb-3 text-primary">Search Engine Optimization (SEO)</h4>
            <p className="text-muted mb-4">Define how your website appears on Google and social media.</p>

            {/* Live Google Search Preview */}
            <div className="mb-4 p-3 border rounded" style={{ backgroundColor: '#f8f9fa' }}>
                <small className="text-muted fw-bold mb-2 d-block">Google Search Preview:</small>
                <div style={{ fontFamily: 'arial, sans-serif' }}>
                    <div style={{ color: '#202124', fontSize: '14px', marginBottom: '2px' }}>
                        www.{formData.branding.companyName.replace(/\s+/g, '').toLowerCase()}.com
                    </div>
                    <div style={{ color: '#1a0dab', fontSize: '20px', cursor: 'pointer', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {formData.seoData.metaTitle || "Your Meta Title Here"}
                    </div>
                    <div style={{ color: '#4d5156', fontSize: '14px', lineHeight: '1.58' }}>
                        {formData.seoData.metaDescription || "Your meta description will appear here. Make it catchy to get more clicks!"}
                    </div>
                </div>
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold">Meta Title</label>
              <input type="text" className="form-control" placeholder="e.g., Best Travel Agency in City" 
                value={formData.seoData.metaTitle} 
                onChange={(e) => setFormData({...formData, seoData: {...formData.seoData, metaTitle: e.target.value}})} 
              />
              <small className="text-muted">Recommended length: 50-60 characters.</small>
            </div>
            
            <div className="mb-3">
              <label className="form-label fw-bold">Meta Description</label>
              <textarea className="form-control" rows="3" placeholder="Briefly describe what your agency offers..." 
                value={formData.seoData.metaDescription} 
                onChange={(e) => setFormData({...formData, seoData: {...formData.seoData, metaDescription: e.target.value}})} 
              ></textarea>
              <small className="text-muted">Recommended length: 150-160 characters.</small>
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold">Keywords</label>
              <input type="text" className="form-control" placeholder="e.g., holiday, flights, dubai tours, travel agency" 
                value={formData.seoData.metaKeywords} 
                onChange={(e) => setFormData({...formData, seoData: {...formData.seoData, metaKeywords: e.target.value}})} 
              />
              <small className="text-muted">Separate keywords with commas.</small>
            </div>
          </div>
        );

      case 7: // Footer
        return (
          <div>
            <h4 className="mb-3 text-primary">Footer Information</h4>
            <div className="mb-3">
              <label className="form-label fw-bold">About Us (Short text for footer)</label>
              <textarea className="form-control" rows="3" value={formData.footer.aboutText} 
                onChange={(e) => setFormData({...formData, footer: {...formData.footer, aboutText: e.target.value}})}
              ></textarea>
            </div>
            <div className="mb-3">
              <label className="form-label fw-bold">Copyright Text</label>
              <input type="text" className="form-control" value={formData.footer.copyright} 
                onChange={(e) => setFormData({...formData, footer: {...formData.footer, copyright: e.target.value}})} 
              />
            </div>
          </div>
        );
        
      default: return null;
    }
  };

  return (
      <div className="wizard-modal-overlay">
      <div className="wizard-modal-content">
        <div className="wizard-stepper">
          {STEPS.map((step, index) => (
            <div key={index} className={`step-indicator ${index === currentStep ? "active" : ""} ${index < currentStep ? "completed" : ""}`}>
              <div className="step-icon">{index < currentStep ? "✓" : index + 1}</div>
              <div className="step-label">{step}</div>
            </div>
          ))}
        </div>
        <div className="wizard-body">
          {loading ? (
            <div className="d-flex flex-column justify-content-center align-items-center p-5 h-100">
               <div className="spinner-border text-primary mb-3" role="status"></div>
               <h5 className="text-muted">Fetching Template Data...</h5>
            </div>
          ) : renderStepContent()}
        </div>
        <div className="wizard-footer">
          <button className="btn btn-outline-secondary px-4" onClick={currentStep === 0 ? onClose : () => setCurrentStep(currentStep - 1)} disabled={loading}>
            {currentStep === 0 ? "Cancel" : "Back"}
          </button>
          {currentStep === STEPS.length - 1 ? (
            <button className="btn btn-success px-5 fw-bold shadow" onClick={handleFinalSave} disabled={loading}>
              🚀 Launch Website
            </button>
          ) : (
            <button className="btn btn-primary px-5 fw-bold shadow" onClick={() => setCurrentStep(currentStep + 1)} disabled={loading}>
              Next Step
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default TemplateSetupWizard;